<script>
import lazyLoadComponent from '@router/lazyload-component'
import Layout from '@layouts/main'
export default {
  page() {
    return {
      title: `${this.$t('prepaid.BASE')}方案`,
      meta: [{ name: 'description', content: 'Prepaid List' }],
    }
  },
  components: {
    Layout,
  },
  props: {
    category: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activeTab: '1',
      tabList: Object.freeze([
        {
          title: '基本設定',
          component: () => lazyLoadComponent(import('./TabBasic')),
        },
        {
          title: '方案設定',
          component: () => lazyLoadComponent(import('./TabPrepaid')),
        },
      ]),
    }
  },
  computed: {
    pageTitle() {
      return this.mode ? (this.mode === 'add' ? `新增${this.tabList[+this.activeTab].title}` : `編輯${this.tabList[+this.activeTab].title}`) : `服務項目`
    },
  },
  watch: {
  },
  mounted(){
    this.$meta().refresh()
  },
  created() {
    
  },
  methods: {
  },
}
</script>

<template>
  <Layout>
    <el-tabs v-model="activeTab" type="border-card" stretch class="isStyleBase">
      <el-tab-pane v-for="(tab, index) in tabList" :key="index" :label="tab.title" :name="`${index}`"> </el-tab-pane>
    </el-tabs>
    <component 
      :is="tabList[activeTab].component" 
      ref="prepaid" 
      :class="$style.pageContent" 
      :category="category"
      @leave="activeTab = '1'"
    >
    </component>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
@import '@src/design/layout_detail_steps.scss';
</style>
